$(() => {
    $('body').on('click touchend', '[data-toggle="class"][data-class]', (event) => {
        event.preventDefault();
        const $trigger = $(event.currentTarget);
        const $target = $(
            $trigger.data('target') ? $trigger.data('target') : $trigger.attr('href')
        );
        const newClass = $trigger.data('class');
        const removePrev = $trigger.data('remove-prev');
        const stayActive = $trigger.data('stay-active');

        if (removePrev && !$target.hasClass(newClass)) {
            const parentSel = $trigger.data('parent');
            $(parentSel).find(`.${newClass}`).removeClass(newClass);
        }

        if ($target.length) {
            event.preventDefault();
            $trigger.toggleClass('class-toggled');
            $trigger.closest( '.aerial-map__pin' ).toggleClass( 'pin-expanded' );
            if (stayActive) {
                $target.addClass(newClass);
            } else {
                $target.toggleClass(newClass);
            }
        }
    });
});
